import Component from '../abstracts/Component';
import Handlebars from 'handlebars';
import {doAjax} from '../utils/ajaxUtil';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import _ from "lodash";

export default class StoreLocatorComponent extends Component {
  get SELECTORS() {
    return {
      inputSearch: '[data-input]',
      clearButton: '[data-clear-search]',
      searchButton: '[data-geolocation]',
      searchResults: '[data-search-results]',
      mapContainer: '[data-map-container]',
      storeCounter: '[data-counter]',
      storeTemplate: '[data-template-store]',
      featuresFilters: '[data-filter-item]',
      filterLabel: '[data-filter-item-label]',
      resultContainer: '[data-results-container]',
      storeItem: '[data-store-id]',
      noResultsContainer: '[data-no-results]'

    }
  }

  get CLASSES() {
    return {
      selected: 'selected',
      hidden: 'hidden',
    }
  }

  constructor(htmlEl) {
    super(htmlEl);


    this.inputSearch = htmlEl.querySelector(this.SELECTORS.inputSearch);
    this.clearButton = htmlEl.querySelector(this.SELECTORS.clearButton);
    this.searchButton = htmlEl.querySelector(this.SELECTORS.searchButton);
    this.searchResults = htmlEl.querySelector(this.SELECTORS.searchResults);
    this.mapContainer = htmlEl.querySelector(this.SELECTORS.mapContainer);
    this.storeCounter = htmlEl.querySelectorAll(this.SELECTORS.storeCounter);
    this.storeTemplate = htmlEl.querySelector(this.SELECTORS.storeTemplate);
    this.featuresFilters = htmlEl.querySelectorAll(this.SELECTORS.featuresFilters);
    this.resultContainer = htmlEl.querySelector(this.SELECTORS.resultContainer);
    this.noResultsContainer = htmlEl.querySelector(this.SELECTORS.noResultsContainer);
    this.TemplateCompile = this.ParsedTemplate;

    this.contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");

    // initialize all "global" variables
    this.googleApiKey;
    this.googleLanguage;
    this.country = $("#country").val();
    this.map;
    this.markers = [];
    this.params = [];
    this.center;
    this.viewport;
    this.token;
    this.activeCard;
  }

  /**
   * Function to inject content in template
   */
  get ParsedTemplate() {
    return Handlebars.compile(this.storeTemplate.innerHTML);
  }

  /**
   * Function to load and register external libraries
   * @returns {Promise} - a promise in order to use callback fns
   */
  async loadLibraries() {
    return new Promise((resolve, reject) => {
      // get data
      this.googleApiKey = $("#googleApiKey").val();
      this.googleLanguage = $("#googleLanguage").val();
      const apiUrl = `https://maps.googleapis.com/maps/api/js?v=quarterly&key=${this.googleApiKey}&libraries=places,geometry&language=${this.googleLanguage}&v=beta`;

      // load google maps script
      this.moduleLoader.loadExternalScript(apiUrl).then(async () => {
        window.GEO_JSON = {};
        // load google maps libraries
        const { Map } = await google.maps.importLibrary('maps');
        this.Map = Map;

        const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
        this.AdvancedMarkerElement = AdvancedMarkerElement;

        const { Geocoder } = await google.maps.importLibrary('geocoding');
        this.Geocoder = Geocoder;

        const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary('places');
        this.AutocompleteSessionToken = AutocompleteSessionToken;
        this.AutocompleteSuggestion = AutocompleteSuggestion;
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }

  /**
   * Function to init map with styles and options
   */
  async initMap() {
    // map styles (now useless, keeping just for reference)
    const _styles = [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ];

    // get initial center and bounds based on country
    const token = new this.AutocompleteSessionToken();
    // geocoder
    const geocoder = new this.Geocoder();
    this.geocoder = geocoder;
    // fill request input with country value
    // let request = { input: this.country };
    let request = { input: this.country };
    request.sessionToken = token;
    // save token for future requests
    this.token = token;
    // get suggestions
    const { suggestions } = await this.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
    // get first result
    const toPlace = suggestions[0].placePrediction.toPlace();
    // fetch useful fields
    await toPlace.fetchFields({
      fields: ['location', 'viewport', 'formattedAddress']
    });
    // set viewport
    this.viewport = toPlace.viewport;
    // set bounds
    const neBounds = toPlace.viewport.getNorthEast();
    const swBounds = toPlace.viewport.getSouthWest();
    this.bounds = {
      northEast: { lat: neBounds.lat(), lng: neBounds.lng() },
      southWest: { lat: swBounds.lat(), lng: swBounds.lng() }
    }
    // set center
    const lat = toPlace.location.lat();
    const lng = toPlace.location.lng();
    this.center = {lat, lng}

    // map options
    const options = {
      disableDefaultUI: true,
      scaleControl: true,
      fullscreenControl: false,
      zoomControl: !(this.isMobile()),
      gestureHandling: 'cooperative',
      mapId: '2fdcac20d6c3453b',
    };

    // Create map
    this.map = new this.Map(this.mapContainer, options);
    this.map.fitBounds(toPlace.viewport);
    // add event listener to reload stores when map's bounds are changed (zoom, drag, ecc...)
    // we need the setTimeout to not trigger the listener for the first fitBounds up here
    setTimeout(() => {
      this.map.addListener('dragend', () => {
        const viewport = this.map.getBounds();
        const location = this.map.getCenter();
        this.searchStores(viewport, location);
      });
      this.map.addListener('zoom_changed', () => {
        const viewport = this.map.getBounds();
        const location = this.map.getCenter();
        this.searchStores(viewport, location);
      });
    }, 500);
  }

  /**
   * Function to detect mobile or desktop
   * @returns {boolean}
   */
  isMobile() {
    const mq = window.matchMedia('(max-width: 1023px)');
    const isMobile = mq.matches;
    return isMobile;
  }

  /**
   * Function to load stores data and create markers and clusters
   * @param {Object} inputData - data object to use in ajax call (optional)
   */
  loadStores(inputData = null) {
    const url = this.contextPath + '/store-locator';
    let data = inputData ? inputData : {
      listJson: true,
      withoutRadius: false,
      country: this.googleLanguage
    };
    // if there are filters, include them in data
    if (this.params.length) {
      data.features = [...this.params];
    }
    doAjax({
      url: url,
      data: data,
      traditional: true,
      success: (resp) => {
        // in any case, clean old markers
        this.clearOldMarkers();
        // set number of results
        this.storeCounter.forEach(store => {
          store.innerHTML = String(resp.features.length);
        });
        // if we have at least one store, proceed
        if (resp.features.length) {
          resp.features.forEach(feature => {
            this.createMarker(feature);
          });
          const markers = this.markers;
          const map = this.map;
          // create marker clusterer
          this.markerClusterer = new MarkerClusterer({
            markers: markers,
            map: map,
            renderer: {
              render: ({
                count,
                position
              }) => {
                // Create a custom cluster HTML element to be used with an AdvancedMarker
                const el = document.createElement("div");
                // set class
                el.className = 'cluster';
                // Set content
                el.textContent = String(count);

                return new this.AdvancedMarkerElement({
                  position: position,
                  content: el,
                  title: 'AdvancedMarkerElement Cluster'
                })
              }
            }
          });
          // create store items template
          this.createStoreItems(resp.features);

          // make mobile carousel
          this.initCarousel();

          // bind event listeners to store items
          this.addListenerToStoreItems();
        } else {
          // clear store items
          this.clearStoreItems();
        }
      }
    })
  }

  /**
   * Function to create custom pin element and marker attached to the map.
   * It also adds an event listener to the marker in order to toggle highlight of it.
   * @param {Object} feature - object that contains all store data
   */
  createMarker(feature) {
    // Create svg for pin. Images are handled via scss
    const pinImg = document.createElement("img");
    pinImg.id = feature.properties.name;
    pinImg.className = 'ib-marker';

    // Create marker
    const marker = new this.AdvancedMarkerElement({
      map: this.map,
      position: { lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0] },
      title: feature.properties.displayName,
      content: pinImg
    });
    // add listener to marker
    marker.addListener('gmp-click', () => {
      this.toggleHighlightMarker(marker);
    })
    this.markers.push(marker);
  }

  /**
   *
   * @param {Array} features - array of object that contains all stores data
   */
  createStoreItems(features) {
    // show results elements
    this.noResultsContainer.classList.add(this.CLASSES.hidden);
    this.resultContainer.classList.remove(this.CLASSES.hidden);

    let storeLoaded = [];
    if (features && features.length) {
      // for every store, create a store item from template
      features.forEach(feature => {
        storeLoaded.push(this.TemplateCompile(feature.properties));
      });
      // inject content to HTML
      this.resultContainer.innerHTML = storeLoaded.join('');
    }
  }

  /**
   * Function to clean all old markers
   */
  clearOldMarkers() {
    // remove markers from map
    this.markers.forEach(marker => {
      marker.map = null;
    });
    this.markers = [];
    // if cluster is active, clean it
    if (this.markerClusterer) this.markerClusterer.clearMarkers();
  }

  /**
   * Function to clear all results items and close results container
   */
  clearStoreItems() {
    // hide results elements
    this.resultContainer.innerHTML = '';
    this.noResultsContainer.classList.remove(this.CLASSES.hidden);
    this.resultContainer.classList.add(this.CLASSES.hidden);
  }

  /**
   * Function to toggle highlight for both marker and store item
   * @param {Object} marker - AdvancedMarkerElement object
   */
  toggleHighlightMarker(marker) {
    // check if marker is already selected
    if (marker.content.classList.contains(this.CLASSES.selected)) {
      // remove selected class for marker
      marker.content.classList.remove(this.CLASSES.selected);
      // deselect store item
      this.selectStoreItem(marker, false);
    } else {
      // remove selected class from all markers
      this.markers.forEach(marker => {
        marker.content.classList.remove(this.CLASSES.selected);
      });
      // add selected class to clicked marker
      marker.content.classList.add(this.CLASSES.selected);
      // select store item
      this.selectStoreItem(marker, true);
    }
  }

  /**
   * Function to select or deselect store item
   * @param {Object} marker - AdvancedMarkerElement object
   * @param {boolean} select - bool that indicates if we have to select or deselect
   */
  selectStoreItem(marker, select) {
    // get all store items
    let storeItems = this.resultContainer.querySelectorAll('[data-store-id]');
    // get store item in question
    let storeItem = this.resultContainer.querySelector(`[data-store-id="${marker.content.id}"]`);
    if (storeItem) {
      if (select) {
        // remove selected class from all store items
        storeItems.forEach(item => {
          item.classList.remove(this.CLASSES.selected);
        });
        // add selected class to store item
        storeItem.classList.add(this.CLASSES.selected);
        storeItem.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        // is a carousel
        if(this.resultContainer.slick && $(this.resultContainer).hasClass('slick-initialized')) {
          const cards = this.resultContainer.querySelectorAll(`[data-store-id="${marker.content.id}"]`);
          let card;
          let cardIndex;
          // avoid slick to break on negative value slide
          for (let c of cards) {
            let cIndex = c.closest("[data-slick-index]").dataset.slickIndex;
            if (cIndex >= 0) {
              card = c;
              cardIndex = cIndex;
              break;
            }
          }
          $(this.resultContainer).slick("slickGoTo", cardIndex);
          const currentSlide = this.resultContainer.querySelector("[data-slick-index='" + this.resultContainer.slick.slickCurrentSlide() + "']");
          this.activeCard ? this.activeCard.classList.remove("selected") : '';
          const currentCard = currentSlide.querySelector(`[data-store-id="${marker.content.id}"]`);
          currentCard.classList.add("selected");
          this.activeCard = currentCard;
        }
      } else {
        // remove selected class from store item
        storeItem.classList.remove(this.CLASSES.selected);
      }
    }
  }

  /**
   * Function to toggle marker selection
   * @param {Object} storeItem - HTML store item
   */
  selectMarker(storeItem) {
    // find marker element
    const marker = this.markers.find(marker => marker.content.id === storeItem.dataset.storeId);
    // toggle highlight marker
    this.toggleHighlightMarker(marker);
  }

  /**
   * Function to toggle selection of filter item
   * @param {HTMLElement} feature - HTML element of filter in question
   */
  handleFilterSelection(feature) {
    if (feature.classList.contains(this.CLASSES.selected)) {
      // deselect filter
      feature.classList.remove(this.CLASSES.selected);
      // remove filter
      this.removeFilterParam(feature);
    } else {
      // select filter
      feature.classList.add(this.CLASSES.selected);
      // add filter
      this.addFilterParam(feature);
    }
  }

  /**
   * Function to add a filter
   * @param {HTMLElement} feature - HTML element of filter in question
   */
  addFilterParam(feature) {
    // add filter
    this.params.push(feature.firstElementChild.value);
    // send event
    this.$emit(this.$customEvents.STORELOCATOR_EVENTS.showReset);
    this.$emit(this.$customEvents.STORELOCATOR_EVENTS.updateCount, {count: this.params.length});
    // reload stores
    this.loadStores();
  }

  /**
   * Function to remove a filter
   * @param {HTMLElement} feature - HTML element of filter in question
   */
  removeFilterParam(feature) {
    // remove filter
    this.params = this.params.filter(p => p != feature.firstElementChild.value);
    // send event
    if(this.params.length == 0) {
      this.$emit(this.$customEvents.STORELOCATOR_EVENTS.hideReset);
    }
    this.$emit(this.$customEvents.STORELOCATOR_EVENTS.updateCount, {count: this.params.length});
    // reload stores
    this.loadStores();
  }

  /**
   * Function to remove all filters
   */
  clearFilters() {
    this.params = [];
    this.featuresFilters.forEach(feature => {
      feature.classList.remove(this.CLASSES.selected);
    });
    // reload stores
    this.loadStores();
  }

  /**
   * Function to add event listener to store items
   */
  addListenerToStoreItems() {
    // get store items
    const storeItems = this.resultContainer.querySelectorAll(this.SELECTORS.storeItem);
    if (storeItems && storeItems.length) {
      // for each store, add a click event listener that toggle marker selection
      storeItems.forEach(storeItem => {
        storeItem.addEventListener('click', () => this.selectMarker(storeItem));
      });
    };
  }

  /**
   * Function to simulate Autocomplete, interrogating Google Maps suggestion service
   * @param {String} text - input text to be searched
   */
  async onSearchInput(event, ctx) {
    event.preventDefault();
    const text = ctx.inputSearch.value;
    let executeSearch = false;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      const activeEl = document.activeElement;
      if (activeEl.classList.contains('form__search-results__item')) {
        activeEl.nextElementSibling.focus();
      } else {
        this.searchResults.children.length > 0 ? this.searchResults.children[0].focus() : '';
      }
      return;
    } else if (event.key === 'Enter') {
      executeSearch = true;
    }
    // clear previous results
    this.searchResults.innerHTML = '';
    if (text) {
      // create request
      const request = {
        input: text,
        origin: ctx.center,
        sessionToken: ctx.token
      };
      // get suggestions
      const { suggestions } = await ctx.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
      if (suggestions.length) {
        if (executeSearch) {
          const placePrediction = suggestions[0].placePrediction;
          const place = placePrediction.toPlace();
          // fetch useful fields
          await place.fetchFields({
            fields: ['location', 'viewport', 'formattedAddress', 'displayName']
          });
          ctx.setMapBoundsAndSearchStores(place.viewport, place.location, place.formattedAddress);
          // hide results
          ctx.searchResults.classList.add(ctx.CLASSES.hidden);
        } else {
          // if results are hidden, show them
          if (ctx.searchResults.classList.contains(ctx.CLASSES.hidden)) {
            ctx.searchResults.classList.remove(ctx.CLASSES.hidden);
          }
          // for every suggestion create a list item and register event listeners
          for (let suggestion of suggestions) {
            const placePrediction = suggestion.placePrediction;
            const place = placePrediction.toPlace();
            // fetch useful fields
            await place.fetchFields({
              fields: ['location', 'viewport', 'formattedAddress']
            });
            const value = placePrediction.text.toString();
            // if this item is not already present, proceed
            if (!ctx.searchResults.children.namedItem(value)) {
              // create a list element
              const listItem = document.createElement('li');
              // set value and tabindex attributes
              listItem.setAttribute('value', value);
              listItem.setAttribute('tabindex', 0);
              // set class
              listItem.classList.add('form__search-results__item');
              // create text node
              listItem.appendChild(
                document.createTextNode(value)
              );
              // register event listener to select list item
              listItem.addEventListener('click', () => {
                ctx.onSelectSearchResultItem(listItem);
                ctx.setMapBoundsAndSearchStores(place.viewport, place.location, place.formattedAddress);
              });
              // register event listener to navigate through list items and select one
              listItem.addEventListener('keydown', (e) => {
                e.preventDefault();
                if (e.key === 'ArrowDown') {
                  if (listItem.nextElementSibling) {
                    listItem.nextElementSibling.focus();
                  }
                }
                if (e.key === 'ArrowUp') {
                  if (listItem.previousElementSibling) {
                    listItem.previousElementSibling.focus();
                  }
                }
                if (e.key === 'Enter') {
                  ctx.onSelectSearchResultItem(listItem);
                  ctx.setMapBoundsAndSearchStores(place.viewport, place.location);
                }
              });
              // append list item to results list
              ctx.searchResults.appendChild(listItem);
            }
          }
        }
      } else {
        // hide results
        ctx.searchResults.classList.add(ctx.CLASSES.hidden);
      }
    } else {
      // hide results
      ctx.searchResults.classList.add(ctx.CLASSES.hidden);
    }
  }

  /**
   * Function to set value in input based on user's selection
   * @param {HTMLLIElement} listItem - HTML <li> element
   */
  onSelectSearchResultItem(listItem) {
    // set input value
    const value = listItem.getAttribute('value');
    this.inputSearch.value = value;
    // close search results
    if (!this.searchResults.classList.contains(this.CLASSES.hidden)) {
      this.searchResults.classList.add(this.CLASSES.hidden);
    }
    // refresh token
    const token = new this.AutocompleteSessionToken();
    this.token = token;
  }

  /**
   * Function to set map bounds and search stores in that area
   * @param {LatLngBounds} viewport - object that contains bounds coordinates (Maps class)
   * @param {LatLng} location - object that contains center coordinates (Maps class)
   * @param String formattedAddress - formatted address of position
   */
  setMapBoundsAndSearchStores(viewport, location, formattedAddress = null) {
    // set map bounds
    this.map.fitBounds(viewport);
    // update search input
    if (formattedAddress) {
      // address comes from google current search
      this.inputSearch.value = formattedAddress;
    } else {
      // for geolocation we don't have an address, launch new search to retrieve it
      this.updateSearchInput(location);
    }
    // search stores in new area
    this.searchStores(viewport, location);
  }

  /**
   * Function to search stores inside an area
   * @param {LatLngBounds} viewport - object that contains bounds coordinates (Maps class)
   * @param {LatLng} location - object that contains center coordinates (Maps class)
   */
  searchStores(viewport, location) {
    // set bounds
    const neBounds = viewport.getNorthEast();
    const swBounds = viewport.getSouthWest();
    this.bounds = {
      northEast: { lat: neBounds.lat(), lng: neBounds.lng() },
      southWest: { lat: swBounds.lat(), lng: swBounds.lng() }
    }
    // set center
    const lat = location.lat;
    const lng = location.lng;
    // create data object
    // NOTICE: lat and lng should be reversed, but service is working with these values
    // (north should be northEast.lng, east should be northEast.lat, ecc...)
    const data = {
      north: this.bounds.northEast.lat,
      east: this.bounds.northEast.lng,
      south: this.bounds.southWest.lat,
      west: this.bounds.southWest.lng,
      lat: lat,
      lng: lng,
      listJson: true,
      withoutRadius: false
    };
    // load stores
    this.loadStores(data);
  }

  /**
   * Function to bind events related to this component
   */
  bindEvents() {
    let ctx = this;

    // if there is search input, proceed
    if (this.inputSearch) {
      const debouncedFunction = (event) => {
        ctx.onSearchInput(event, ctx);
      }
      this.inputSearch.addEventListener('keydown', _.debounce(debouncedFunction, 300));
    }

    // if there is clear button, proceed
    if (this.clearButton) {
      // add event listenere to clear input search
      this.clearButton.addEventListener('click', () => {
        if (ctx.inputSearch) ctx.inputSearch.value = '';
        // hide results
        this.searchResults.classList.add(this.CLASSES.hidden);
        this.searchResults.innerHTML = '';
      });
    };

    // if there is search button, proceed
    if (this.searchButton) {
      this.searchButton.addEventListener('click', (e) => {
        // prevent default submit event
        e.preventDefault();
        // get geolocation from browser geolocation, if present
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              if(pos.lat && pos.lng) {
                this.center = pos;
              }
              // move map
              this.map.setCenter(pos);
              this.map.setZoom(10);
              // update search input
              this.updateSearchInput(pos);
              // load stores
              this.loadStores({
                lat: pos.lat,
                lng: pos.lng,
                listJson: true,
                withoutRadius: false
              });
            }
          ),
          () => {
            window.alert('Servizi di geolocalizzazione non disponibili')
          }
        }
      })
    }

    // if there are filters, proceed
    if (this.featuresFilters && this.featuresFilters.length) {
      // for each filter, add event listener
      this.featuresFilters.forEach(feature => {
        // add listener to wrapper
        feature.addEventListener('click', (event) => {
          event.stopPropagation();
          // toggle filter selection
          this.handleFilterSelection(feature);
        });
        // add listener also to children
        if(feature.querySelector(this.SELECTORS.filterLabel)) {
          feature.querySelector(this.SELECTORS.filterLabel).addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            // toggle filter selection
            this.handleFilterSelection(feature);
          });
        }
      });
      // listen for event to clear all filters and reload stores
      this.$on(this.$customEvents.STORELOCATOR_EVENTS.clearFilters, event => {
        this.clearFilters();
      });
    }
  }

  updateSearchInput(position) {
    this.geocoder.geocode({location: position}).then(({results}) => {
      if (results.length) {
        results.forEach(address => {
          // get generic city address, like autosuggestions
          if (address.address_components[0].types[0] === 'locality') {
            this.inputSearch.value = address.formatted_address;
          }
        });
      }
    });
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        if(window.matchMedia('(min-width: 1024px)').matches) {
          this.initCarousel();
        }
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousel() {
    const options = {
      arrows: false,
      variableWidth: true,
      centerMode: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: "unslick"
        }
      ],
    };
    //save the current innerHTML because slick("unslick") resets innerHTML to current slick slider's slides content
    const innerHTML = this.resultContainer.innerHTML;
    if($(this.resultContainer).hasClass('slick-initialized')) {
      $(this.resultContainer).slick("unslick");
    }
    this.resultContainer.innerHTML = innerHTML;
    $(this.resultContainer).slick(options);
  }

  render() {
    super.render();

    // Load libraries
    this.loadLibraries().then(() => {
      // Init map
      this.initMap();
      // mobile carousel
      this.importSlick();
      // Load stores
      this.loadStores();
      // Bind events
      this.bindEvents();
    });
  }
}
